import BulkOrder from "./BulkOrder";
import SingleOrder from "./SingleOrder";
import SendPrioritySetting from "../SendPrioritySetting";
import ImbalanceSetting from "../ImbalanceSetting";

const AddOrderBox = () => {
  return (
    <div className="flex flex-col justify-start items-center gap-5">
      <SingleOrder />
      <div className="grid w-80 grid-cols-2 gap-2">
        <SendPrioritySetting />
        <ImbalanceSetting />
      </div>
      <BulkOrder />
    </div>
  );
};

export default AddOrderBox;
